import React, { useState, useEffect, useMemo } from "react";
import { Dialog, DialogTitle, Autocomplete, DialogContent, Button, TextField, RadioGroup, Radio, FormControlLabel, Box, Typography, Grid, IconButton, FormHelperText, DialogContentText, DialogActions, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { RxCross2 } from "react-icons/rx";

// Note: unused imports can be removed later
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import { usePermission } from "hooks/usePermission";
import { useUpdateLegalMutation } from "store/slices/apis/legalTrackerSlice";
import { Category } from "@mui/icons-material";
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from "@mui/icons-material/Close";



const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const LEGAL_TYPES = [
    { label: "BOCW", value: "BOCW" },
    { label: "WC & Migrant Worker", value: "WMW" },
    { label: "CEA", value: "CEA" },
    { label: "Environment", value: "Environment" },
    { label: "Motor Vehicle Act", value: "MVA" },
];
// const statusOptions = [
//     { label: "Complied", value: "Complied" },
//     { label: "Not Complied", value: "Not Complied" },
//     { label: "Not Applicable", value: "Not Applicable" }
// ]

const MAX_TOTAL_SIZE = 30 * 1000 * 1000;

const EditLegal = (props) => {
    const { open, handleClose, rowData, refetchCounts } = props;
    console.log("rowdata", rowData)
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const module = "legal Compliance"
    const { data: contactsData, isLoading, error } = useGetAllContactsQuery();
    const { data: statusData } = useGetMasterDataQuery({ module: module, category: 'StatusofCompliance', ProjectId: projectId });
    const [toRemoveCompliances, setToRemoveCompliances] = useState([]);
    const [imageConflicts, setImageConflicts] = useState(null);
    const [pendingFormValues, setPendingFormValues] = useState(null);
    const [isConfirm, setIsConfirm] = useState(false);
    const [loadingType, setLoadingType] = useState(null);

    const responsiblePersonOptions = React.useMemo(() => {
        if (!contactsData?.data) return [];

        return contactsData.data.map((item) => ({
            value: item.email,
            label: `${item.name}`,
        }));
    }, [contactsData]);

    const statusOptions = statusData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    })) || [];

    const [updateLegal] = useUpdateLegalMutation()



    const isAdminAccess = usePermission();
    // const [updateDpItems] = useEditProcurementDpItemsMutation();

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        return moment(dateString).format("YYYY-MM-DD");
    };


    const [initialFormData, setInitialFormData] = useState({
        sectionRuleClause: "",
        applicableRequirementOfSection: "",
        requirementOfCompliance: "",
        complianceFrequency: "",
        responsibility: "",
        statusCompliance: "",
        complianceEvidence: "",
        remarks: "",
        type: "",
        category: ""
    });

    useEffect(() => {
        if (rowData && open) {
            const formattedData = {
                sectionRuleClause: rowData.sectionRuleClause || "",
                applicableRequirementOfSection: rowData.applicableRequirement || "",
                requirementOfCompliance: rowData.requirementOfCompliance || "",
                complianceFrequency: rowData.complianceFrequency || "",
                responsibility: rowData.responsibility || "",
                statusCompliance: rowData.statusOfCompliance || "",
                complianceEvidence: rowData.complianceEvidence || [],
                remarks: rowData.remarks || "",
                type: rowData.type || "",
                category: rowData?.category || ""
            };
            setInitialFormData(formattedData);
        }
    }, [rowData, open]);


    const validationSchema = Yup.object({
        // sectionRuleClause: Yup.string().required("Section/Rule/Clause is required"),
        applicableRequirementOfSection: Yup.string().required("Applicable requirement is required"),
        // requirementOfCompliance: Yup.string().required("Requirement of Compliance is required"),
        // complianceFrequency: Yup.string().required("Compliance of frequency is required"),
        // responsibility: Yup.string().required("Responsibility is required"),
        // statusCompliance: Yup.string().required("Status of Compliance is required"),
    });

    const validate = (values) => {
        const errors = {};

        const allFiles = [
            ...(values?.complianceEvidence?.filter(file => !file?.filePath) || [])
        ];

        const totalSize = allFiles.reduce((acc, file) => acc + file.size, 0);

        if (totalSize >= MAX_TOTAL_SIZE) {
            errors.complianceEvidence = "Total file size must be less than 30MB";
        }

        return errors;
    };


    const submitLegal = async (values, isOveride = null) => {
        // const reqBody = {
        //     projectId: projectId,
        //     legalRegisterId: rowData.legalRegisterId,
        //     type: values?.type || "",
        //     sectionRuleClause: values.sectionRuleClause,
        //     applicableRequirement: values.applicableRequirementOfSection,
        //     requirementOfCompliance: values.requirementOfCompliance,
        //     complianceFrequency: values.complianceFrequency,
        //     responsibility: values.responsibility,
        //     statusOfCompliance: values.statusCompliance,
        //     complianceEvidence: values.complianceEvidence,
        //     remarks: values.remarks,
        //     category: values?.category || ""
        // };
        const formData = new FormData();

        formData.append("ProjectId", projectId);
        formData.append("LegalRegisterId", rowData.legalRegisterId);
        formData.append("Category", values?.category || "");
        formData.append("Type", values?.type || "");
        formData.append("SectionRuleClause", values.sectionRuleClause || "");
        formData.append("ApplicableRequirement", values.applicableRequirementOfSection || "");
        formData.append("RequirementOfCompliance", values.requirementOfCompliance || "");
        formData.append("ComplianceFrequency", values.complianceFrequency || "");
        formData.append("Responsibility", values.responsibility || "");
        formData.append("StatusOfCompliance", values.statusCompliance || "");
        formData.append("Remarks", values.remarks || "");
        formData.append("IsActive", true);

        if (values.complianceEvidence?.length) {
            values.complianceEvidence.forEach((file) => {
                formData.append("NewComplianceEvidenceFiles", file);
            });
        }
        toRemoveCompliances.forEach((id) => {
            formData.append("DeleteLegalFileIds", id);
        });

        if (isOveride !== null) {
            formData.append("OverrideExistingFiles", isOveride);
        }

        const response = await updateLegal(formData).unwrap();
        return response
    }

    const handleSubmit = async (values, { setSubmitting }) => {
        console.log("values", values)

        try {
            const resp = await submitLegal(values);
            console.log("response", resp)
            if (resp?.status === "Warning") {
                setImageConflicts(resp?.data);
                setPendingFormValues(values);
                setIsConfirm(true);
                return
            }
            openNotification(resp?.message, "success");
            refetchCounts()
            setSubmitting(false);
            handleClose();
        } catch (error) {
            //openNotification(error?.error ?? "Something went wrong", "error");
            console.log("API ERROR:", error);

            let errorMessage = "Something went wrong";

            if (error?.data?.errors) {
                errorMessage = Object.values(error.data.errors)
                    .flat()
                    .join(", ");
            } else if (error?.data?.title) {
                errorMessage = error.data.title;
            } else if (error?.error) {
                errorMessage = error.error;
            }
            openNotification(errorMessage, "error");
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: { color: type },
                close: false,
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleRemoveComplianceEvidence = (index, setFieldValue, values) => {
        const updateImages = values.complianceEvidence.filter((item, imgIdx) => imgIdx !== index)
        setFieldValue("complianceEvidence", updateImages)
        const toRemove = values.complianceEvidence[index];
        if (toRemove?.filePath) {
            setToRemoveCompliances(p => [...p, toRemove?.fileId])
        }
    }

    const handleSkip = async () => {
        setLoadingType("skip");
        try {
            await submitLegal(pendingFormValues, false);
            openNotification("Legal Register updated successfully", "success");
            refetchCounts()
            setIsConfirm(false);
            handleClose();
        } catch (error) {
            let errorMessage = "Something went wrong";

            if (error?.data?.errors) {
                errorMessage = Object.values(error.data.errors)
                    .flat()
                    .join(", ");
            } else if (error?.data?.title) {
                errorMessage = error.data.title;
            } else if (error?.error) {
                errorMessage = error.error;
            }
            openNotification(errorMessage, "error");
        } finally {
            setLoadingType(null);
        }
    };

    const handleReplace = async () => {
        setLoadingType("replace");
        try {
            await submitLegal(pendingFormValues, true);
            openNotification("Legal Register updated successfully", "success");
            refetchCounts()
            setIsConfirm(false);
            handleClose();
        } catch (error) {
            let errorMessage = "Something went wrong";

            if (error?.data?.errors) {
                errorMessage = Object.values(error.data.errors)
                    .flat()
                    .join(", ");
            } else if (error?.data?.title) {
                errorMessage = error.data.title;
            } else if (error?.error) {
                errorMessage = error.error;
            }
            openNotification(errorMessage, "error");
        } finally {
            setLoadingType(null);
        }
    };

    const handleConfirmClose = () => {
        setPendingFormValues(null)
        setIsConfirm(false)
    }

    return (
        <>
            <Dialog
                open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden"
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                    position: "relative",
                }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        Edit Legal Item
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 50,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 size={30} color="#140F36" />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>

                    <Formik
                        enableReinitialize
                        initialValues={initialFormData}
                        validationSchema={validationSchema}
                        validate={validate}
                        onSubmit={handleSubmit}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <RadioGroup
                                        row
                                        name="type"
                                        value={values.type}
                                        onChange={handleChange}
                                    >
                                        {LEGAL_TYPES.map((t) => (
                                            <FormControlLabel
                                                key={t.value}
                                                value={t.value}
                                                control={<Radio />}
                                                label={t.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Category</Typography>
                                        <TextField
                                            fullWidth
                                            name="category"
                                            value={values.category}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Category"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.category && errors.category && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.category}
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Section/Rule/Clause</Typography>
                                        <TextField
                                            fullWidth
                                            name="sectionRuleClause"
                                            value={values.sectionRuleClause}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Section/Rule/Clause"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.sectionRuleClause && errors.sectionRuleClause && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.sectionRuleClause}
                                            </Typography>
                                        )}
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Compliance Frequency</Typography>
                                        <TextField
                                            fullWidth
                                            name="complianceFrequency"
                                            value={values.complianceFrequency}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter compliance frequency"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.complianceFrequency && errors.complianceFrequency && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.complianceFrequency}
                                            </Typography>
                                        )}
                                    </Grid>


                                    {/* <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>Responsibility</Typography>
                                    <Autocomplete
                                        options={responsiblePersonOptions}
                                        getOptionLabel={(option) => option?.label || ''}
                                        value={responsiblePersonOptions.find(opt => opt.value === values.responsibility) || null}
                                        onChange={(_, newValue) => setFieldValue('responsibility', newValue ? newValue.value : '')}
                                        onBlur={handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select Responsibility"
                                                name="responsibility"
                                                size="small"
                                                sx={{
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                }}
                                            />
                                        )}
                                        ListboxProps={{ sx: { fontSize: '13px' } }}
                                    />
                                    {touched.responsibility && errors.responsibility && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.responsibility}
                                        </Typography>
                                    )}
                                </Grid> */}
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Responsibility</Typography>
                                        <TextField
                                            fullWidth
                                            name="responsibility"
                                            value={values.responsibility}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Responsibility"
                                            InputProps={{
                                                sx: {
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#fff",
                                                    "& input::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& input": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 1000px white inset",
                                                            WebkitTextFillColor: "#0A0A0C",
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.responsibility && errors.responsibility && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.responsibility}
                                            </Typography>
                                        )}
                                    </Grid>




                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Requirement of Compliance</Typography>

                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name="requirementOfCompliance"
                                            value={values.requirementOfCompliance}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter Requirement Of Compliance"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& textarea::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& textarea": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.requirementOfCompliance && errors.requirementOfCompliance && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.requirementOfCompliance}
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Applicable requirement of the section/Rules/Clause</Typography>
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name="applicableRequirementOfSection"
                                            value={values.applicableRequirementOfSection}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter applicable requirement"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& textarea::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& textarea": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.applicableRequirementOfSection && errors.applicableRequirementOfSection && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.applicableRequirementOfSection}
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 12 }}>
                                        <Typography sx={labelTextStyle}>Remarks</Typography>
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name="remarks"
                                            value={values.remarks}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Enter remarks"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#fff",
                                                    "& textarea::placeholder": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#5F5F5F",
                                                        fontFamily: "Outfit, sans-serif",
                                                        opacity: 1,
                                                    },
                                                    "& textarea": {
                                                        fontWeight: 400,
                                                        fontSize: "16px",
                                                        color: "#0A0A0C",
                                                        fontFamily: "Outfit, sans-serif",
                                                    },
                                                },
                                            }}
                                        />
                                        {touched.remarks && errors.remarks && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.remarks}
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Status of Compliance</Typography>
                                        <Autocomplete
                                            options={statusOptions}
                                            getOptionLabel={(option) => option?.label || ''}
                                            value={statusOptions.find(opt => opt.value === values.statusCompliance) || null}
                                            onChange={(_, newValue) => setFieldValue('statusCompliance', newValue ? newValue.value : '')}
                                            onBlur={handleBlur}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select status"
                                                    name="statusCompliance"
                                                    size="small"
                                                    sx={{
                                                        "& input::placeholder": {
                                                            fontWeight: 400,
                                                            fontSize: "16px",
                                                            color: "#5F5F5F",
                                                            fontFamily: "Outfit, sans-serif",
                                                            opacity: 1,
                                                        },
                                                    }}
                                                />
                                            )}
                                            ListboxProps={{ sx: { fontSize: '13px' } }}
                                        />
                                        {touched.statusCompliance && errors.statusCompliance && (
                                            <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>
                                                {errors.statusCompliance}
                                            </FormHelperText>
                                        )}
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>Compliance Evidence</Typography>
                                        {/* <TextField
                                        fullWidth
                                        name="complianceEvidence"
                                        value={values.complianceEvidence}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter compliance evidence"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "4px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    color: "#5F5F5F",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.complianceEvidence && errors.complianceEvidence && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.complianceEvidence}
                                        </Typography>
                                    )} */}
                                        <Button variant="outlined" component="label" fullWidth sx={{ height: "40px" }}>
                                            Upload
                                            <input
                                                type="file"
                                                hidden
                                                multiple
                                                accept="image/*"
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files);
                                                    setFieldValue("complianceEvidence", [
                                                        ...values.complianceEvidence,
                                                        ...files
                                                    ]);
                                                }}
                                            />
                                        </Button>
                                        {touched.complianceEvidence && errors.complianceEvidence && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.complianceEvidence}
                                            </Typography>
                                        )}


                                        <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                                            {values.complianceEvidence.map((file, index) => (
                                                <Box key={index} textAlign="center" sx={{ position: "relative" }}>
                                                    {file?.filePath ? <img
                                                        src={file?.filePath}
                                                        alt="preview"
                                                        width={80}
                                                        height={80}
                                                        style={{ objectFit: "cover", borderRadius: 6 }}
                                                    /> : <img
                                                        src={URL.createObjectURL(file)}
                                                        alt="preview"
                                                        width={80}
                                                        height={80}
                                                        style={{ objectFit: "cover", borderRadius: 6 }}
                                                    />}
                                                    <IconButton
                                                        onClick={() => handleRemoveComplianceEvidence(index, setFieldValue, values)}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 1,
                                                            right: 1,
                                                            p: 0,
                                                            backgroundColor: "rgba(0,0,0,0.6)",
                                                            color: "#fff",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(244,67,54,0.9)"
                                                            },
                                                            zIndex: 2
                                                        }}>
                                                        <CancelIcon />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>


                                    <Grid size={12}>
                                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                            <Button
                                                onClick={handleClose}
                                                sx={{
                                                    textTransform: "none",
                                                    color: "#F15744",
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    borderRadius: "25px",
                                                    fontWeight: 500,
                                                    px: "20px",
                                                    py: "15px",
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                disabled={isSubmitting}
                                                sx={{
                                                    backgroundColor: "#00344C",
                                                    borderRadius: "25px",
                                                    textTransform: "none",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#FFFFFF",
                                                    px: "20px",
                                                    py: "15px",
                                                    '&:hover': {
                                                        backgroundColor: "#002233",
                                                    }
                                                }}
                                            >
                                                {isSubmitting ? "Saving..." : "Save"}
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
            <ConfirmDialog
                open={isConfirm}
                imageConflicts={imageConflicts || {}}
                loadingType={loadingType}
                handleClose={handleConfirmClose}
                handleReplace={handleReplace}
                handleSkip={handleSkip}
            />
        </>
    );
};

export default EditLegal;




const ConfirmDialog = ({ open, handleClose, handleSkip, handleReplace, imageConflicts, loadingType }) => {
    return <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
            sx: { borderRadius: "3px", position: "relative" },
        }}
        maxWidth="md"
    >
        <IconButton
            onClick={handleClose}
            sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "grey.600",
            }}
        >
            <CloseIcon />
        </IconButton>
        <DialogTitle
            sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1 }}
        >
            <Typography variant="h6" component="span" fontWeight="600">
                Photographs Conflict
            </Typography>
        </DialogTitle>

        <DialogContent sx={{ width: "600px", }}>
            <DialogContentText sx={{ color: "text.secondary", fontSize: "0.95rem" }}>
                <Typography sx={{ mb: 1 }}>
                    Some images with the same name already exist. Please choose an action:
                </Typography>

                {imageConflicts?.complianceConflicts?.length > 0 && (
                    <Box>
                        <Typography fontWeight="600">Compliance Photographs</Typography>
                        {imageConflicts.complianceConflicts.map((file, index) => (
                            <Typography key={index} sx={{ fontSize: "0.9rem" }}>
                                • {file}
                            </Typography>
                        ))}
                    </Box>
                )}

            </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
                disabled={loadingType !== null}
                sx={{
                    color: "text.secondary",
                    fontWeight: "bold",
                    textTransform: "none",
                    display: "flex",
                    gap: 1,
                }}
                onClick={handleSkip}
            >
                {loadingType === "skip" && <CircularProgress size={16} />}
                Skip Duplicates
            </Button>

            <Button
                variant="contained"
                color="error"
                disableElevation
                disabled={loadingType !== null}
                sx={{
                    borderRadius: "8px",
                    px: 3,
                    fontWeight: "bold",
                    textTransform: "none",
                    display: "flex",
                    gap: 1,
                }}
                onClick={handleReplace}
            >
                {loadingType === "replace" && <CircularProgress size={16} color="inherit" />}
                Replace Existing
            </Button>
        </DialogActions>
    </Dialog>
}